import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unlinkConfirmationModalTitle: {
		id: 'native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-confirmation.modal-title.non-final',
		defaultMessage: 'Unlink {issueKey} from this work item.',
		description: 'Unlink modal confirmation title with issue key',
	},
	unlinkConfirmationCancelButton: {
		id: 'native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-confirmation.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Text for the button used to cancel the modal without unlinking the issue',
	},
	unlinkConfirmationConfirmButton: {
		id: 'native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-confirmation.confirm-button',
		defaultMessage: 'Confirm',
		description: 'Text for the button used to confirm unlink action',
	},
	unlinkSuccessTitle: {
		id: 'native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-success.title.non-final',
		defaultMessage: 'Issue unlinked successfully',
		description: 'Title for success flag when issue is unlinked',
	},
	unlinkSuccessDescription: {
		id: 'native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-success.description.non-final',
		defaultMessage: '{issueKey} has been unlinked from this work item.',
		description: 'Description for success flag when issue is unlinked',
	},
	unlinkErrorTitle: {
		id: 'native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-error.title.non-final',
		defaultMessage: 'Failed to unlink issue',
		description: 'Title for error flag when unlinking fails',
	},
	unlinkErrorDescription: {
		id: 'native-issue-table.common.ui.issue-cells.link-relationship-type.unlink-error.description.non-final',
		defaultMessage: 'An unexpected error occurred while unlinking the issue.',
		description: 'Description for error flag when unlinking fails',
	},
});
